import { createActionGroup, props } from '@ngrx/store'

import { Message, SendFeedbackPayload } from '@flowx/designer/modules/new-ai/common/ai.dictionary'

export const AiAssistantActions = createActionGroup({
  source: 'AiAssistant',
  events: {
    getAnswer: props<{ prompt: string; appId: string; appVersion: string; processDoc: boolean }>(),
    getAnswerEventStream: props<{
      response: Partial<Message>
    }>(),
    getAnswerEventStreamOld: props<{
      response: Partial<Message>
    }>(),
    sendFeedback: props<{ payload: SendFeedbackPayload }>(),
  },
})
